import { render, staticRenderFns } from "./YearDropdownSelect.vue?vue&type=template&id=12562a42&"
import script from "./YearDropdownSelect.vue?vue&type=script&lang=ts&"
export * from "./YearDropdownSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports